'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var moment = _interopDefault(require('moment'));

var convertTime = function (timeVal) {
    var today = moment();
    if (timeVal.isSame(today, 'd')) {
        return timeVal.format('LT');
    }
    if (timeVal.isSame(today, 'week')) {
        return timeVal.format('ddd');
    }
    return timeVal.format('l');
};

exports.convertTime = convertTime;
